import Config   from './provider/config'
import value2mq from './helpers/value2mq'

import { isObject, hasProp } from 'vessel/utils'

const inBrowser = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined'

const screens = Object.keys(Config.screens).sort((a, b) => {
  return parseInt(Config.screens[a]) > parseInt(Config.screens[b]) ? -1 : 1
})

class Plugin {
  constructor(vue) {
    this.$vm = vue

    this.setScreen()
    this.init()
  }

  init() {
    this.checkTouch()
    this.setCurrentBreakpoint()
  }

  get breakpoints() {
    return Config.screens
  }

  get currentBreakpoint() {
    const current = screens.find(bp => this.screen[bp] == true)
    return current || 'xs'
  }

  setScreen() {
    const matchValue = (value, current) => {
      const items = [...screens].reverse()
      const index = items.findIndex(name => name == current)
      const match = items.slice(0, index).reverse().find(name => hasProp(name, value))

      if (current == 'xs' && hasProp('all', value)) {
        return value.all
      } else {
        return value[match || 'all']
      }
    }

    this.screen = this.$vm.observable({
      touch: true,
      portrait: true,
      landscape: false,
      current: 'xs',
      is(value) {
        return this.current == value
      },
      min(value) {
        return this[value] === true
      },
      max(value) {
        return this[value] === false
      },
      between(min, max) {
        return this.min(min) && this.max(max)
      },
      match(value) {
        if (isObject(value)) {
          return hasProp(this.current, value)
            ? value[this.current]
            : matchValue(value, this.current)
        } else {
          return value
        }
      }
    })

    screens.forEach(name => {
      this.$vm.set(this.screen, name, false)
    })

    if (inBrowser) {
      this.initBreakpointQueries()
      this.initOrientationQueries()
    } else {
      screens.forEach(bp => {
        this.screen[bp] = bp == 'xs' || bp == 'sm'
      })
    }
  }

  setCurrentBreakpoint() {
    this.mediaStateChanged('current', this.currentBreakpoint)
  }

  checkTouch() {
    if (inBrowser) {
      this.screen.touch = 'ontouchstart' in window
    }
  }

  mediaStateChanged(name, matches) {
    this.$vm.set(this.screen, name, matches)
  }

  initBreakpointQueries() {
    screens.forEach(name => {
      const query = value2mq({ minWidth: this.breakpoints[name] })
      const media = window.matchMedia(query)

      media.addListener(event => {
        this.mediaStateChanged(name, event.matches)
        this.setCurrentBreakpoint()
      })

      this.mediaStateChanged(name, media.matches)
      this.setCurrentBreakpoint()
    })
  }

  initOrientationQueries() {
    const query = value2mq({ orientation: 'portrait' })
    const media = window.matchMedia(query)

    media.addListener(event => {
      this.mediaStateChanged('portrait', event.matches)
      this.mediaStateChanged('landscape', !event.matches)
      this.setCurrentBreakpoint()
    });

    this.mediaStateChanged('portrait', media.matches)
    this.mediaStateChanged('landscape', !media.matches)
    this.setCurrentBreakpoint()
  }
}

export default {
  install(Vue) {
    const plugin = new Plugin(Vue)
    Vue.prototype.$screen = plugin.screen
  }
}
